
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { calledUpgradeParam } from "@/api/api-basic-websocket";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class PiUpgradeMadel extends Vue {
  private formInline: objAny = {
    host: "",
    port: "",
    userName: "",
    password: "",
    fileDir: "",
    pilePkId: ""
  };
  private modalShow = false;
  private loading = false;
  private formObj: objAny = {};
  private ruleInline: objAny = {
    // host: [{ required: true, message: "请输入主机Ip地址", trigger: "blur" }],
    // port: [{ required: true, message: "请输入主机端口", trigger: "blur" }],
    // userName: [{ required: true, message: "请输入FTP用户名", trigger: "blur" }],
    // password: [
    //   { required: true, message: "请输入FTP用户密码", trigger: "blur" }
    // ],
    // fileDir: [{ required: true, message: "请输入文件目录", trigger: "blur" }]
  };

  public open(pilePkId: string) {
    this.formInline.pilePkId = pilePkId;
    this.modalShow = true;
  }
  public handleSubmit() {
    this.formObj.validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      }
    });
  }
  async submitData(): Promise<void> {
    this.loading = true;
    const ret = await calledUpgradeParam(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operData.success"));
      this.$emit("success");
      this.modalShow = false;
    }
    this.loading = false;
  }

  mounted() {
    this.$nextTick(() => {
      this.formObj = this.$refs.formInline;
    });
  }
}
